import type { InitOptions, FallbackLngObjList } from 'i18next';

import { I18NEXT_LOCALE_KEY } from '@adsk/alloy-react-locale';

export const fallbackLng: FallbackLngObjList = {
  en: ['en-GB'],
  'zh-CN': ['zh-Hans'],
  'zh-TW': ['zh-Hant'],
  'zh-HK': ['zh-Hant-HK'],
  // in the case project does not have base language locales
  // we can fall back to a specific regional version
  cs: ['cs-CZ'],
  da: ['da-DK'],
  de: ['de-DE'],
  es: ['es-ES'],
  fi: ['fi-FI'],
  fr: ['fr-FR'],
  it: ['it-IT'],
  ja: ['ja-JP'],
  nb: ['nb-NO'],
  nl: ['nl-NL'],
  pl: ['pl-PL'],
  pt: ['pt-BR'],
  ru: ['ru-RU'],
  sv: ['sv-SE'],
  zh: ['zh-CN'],
};

const defaultConfig: InitOptions = {
  // https://www.i18next.com/overview/configuration-options
  // allow keys to be phrases having `:`, `.`
  nsSeparator: false,
  keySeparator: false,

  fallbackLng,

  // https://github.com/i18next/i18next-browser-languageDetector#detector-options
  detection: {
    // DSGN-1846 reverses DSGN-1392's navigator-only order so that the user's
    // preferred locale persisted by LocaleProvider survives page reloads.
    // The original rationale ("do not cache so browser-setting changes take effect")
    // is preserved by caches: [] — i18next must not auto-write the key;
    // LocaleProvider is the sole owner of the localStorage write.
    order: ['localStorage', 'navigator'],
    lookupLocalStorage: I18NEXT_LOCALE_KEY,
    caches: [],
  },
};

export default defaultConfig;
